module.exports = __webpack_public_path__ + "static/team-chris-kelly.67b322b1.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/static/img/team-chris-kelly.jpg
// module id = 314
// module chunks = 0 1